import { useState } from "react";
import "../../css/UserEditModal.css";
import "../../css/SiteAdminModals.css";

interface AddCompanyModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (data: { name: string; email: string; companyName: string; subscriptionType: string }) => void;
    isCreating: boolean;
}

const SUBSCRIPTION_OPTIONS = [
    { value: "paid-full-access", label: "Full Access", desc: "Full paid subscription — all core modules accessible" },
    { value: "paid-limited-access", label: "Limited Subscription", desc: "Paid with limits on users and equipment" },
    { value: "free-demo", label: "Free Demo", desc: "Basic trial with limited access" },
];

export const AddCompanyModal = ({ isOpen, onClose, onSubmit, isCreating }: AddCompanyModalProps) => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [subscriptionType, setSubscriptionType] = useState("");

    if (!isOpen) return null;

    const canSubmit = name.trim() && email.trim() && subscriptionType;

    const handleSubmit = () => {
        if (!canSubmit || isCreating) return;
        onSubmit({ name: name.trim(), email: email.trim(), companyName: companyName.trim(), subscriptionType });
        setName("");
        setEmail("");
        setCompanyName("");
        setSubscriptionType("");
    };

    const handleClose = () => {
        setName("");
        setEmail("");
        setCompanyName("");
        setSubscriptionType("");
        onClose();
    };

    return (
        <div className="uem-overlay" onClick={handleClose}>
            <div className="uem-modal" onClick={(e) => e.stopPropagation()}>
                <div className="uem-header">
                    <h2>Add Company Owner</h2>
                    <button className="uem-close" onClick={handleClose} aria-label="Close modal">×</button>
                </div>
                <div className="uem-body">
                    <div className="uem-section">
                        <div className="uem-field">
                            <label>Owner Name</label>
                            <input type="text" value={name} placeholder="e.g. Mark Stratton" onChange={(e) => setName(e.target.value)} />
                        </div>
                    </div>
                    <div className="uem-section">
                        <div className="uem-field">
                            <label>Email Address</label>
                            <input type="email" value={email} placeholder="e.g. mark@company.com" onChange={(e) => setEmail(e.target.value)} />
                        </div>
                    </div>
                    <div className="uem-section">
                        <div className="uem-field">
                            <label>Company Name</label>
                            <input type="text" value={companyName} placeholder="e.g. Basin Rock Products" onChange={(e) => setCompanyName(e.target.value)} />
                        </div>
                    </div>
                    <div className="uem-section">
                        <label className="uem-section-label">Subscription Type</label>
                        <div className="uem-radio-cards">
                            {SUBSCRIPTION_OPTIONS.map((opt) => (
                                <label key={opt.value} className={`uem-radio-card ${subscriptionType === opt.value ? "selected" : ""}`}>
                                    <input type="radio" name="subscriptionType" value={opt.value} checked={subscriptionType === opt.value} onChange={() => setSubscriptionType(opt.value)} />
                                    <div className="uem-radio-card-content">
                                        <div className="uem-radio-card-title">{opt.label}</div>
                                        <div className="uem-radio-card-desc">{opt.desc}</div>
                                    </div>
                                </label>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="uem-footer">
                    <button type="button" className="uem-btn-cancel" onClick={handleClose}>Cancel</button>
                    <button type="button" className="uem-btn-submit" disabled={!canSubmit || isCreating} onClick={handleSubmit}>
                        {isCreating ? "Creating..." : "Create Account"}
                    </button>
                </div>
            </div>
        </div>
    );
};
